import { Image, Skeleton } from '@mantine/core';
import { useQuery } from '@tanstack/react-query';
import { api } from '@prooffleet/client';

interface EvidencePhotoProps {
  objectKey: string;
  versionId: string | null;
  height?: number;
  alt?: string;
}

/**
 * Снимок из доказательной базы.
 *
 * Ссылка подписанная и живёт пять минут, поэтому запрашивается по месту,
 * а не хранится. Версия закреплена: Object Lock защищает версии, а не имена,
 * и без неё показалась бы та, что положили поверх.
 */
export function EvidencePhoto({
  objectKey,
  versionId,
  height = 96,
  alt = '',
}: EvidencePhotoProps): React.JSX.Element {
  const { data, isLoading } = useQuery({
    queryKey: ['evidence', objectKey, versionId],
    queryFn: () =>
      api<{ url: string }>(
        `/evidence/view?objectKey=${encodeURIComponent(objectKey)}` +
          (versionId === null ? '' : `&versionId=${encodeURIComponent(versionId)}`),
      ),
    staleTime: 4 * 60_000,
  });

  if (isLoading || data === undefined) return <Skeleton height={height} radius="sm" />;
  return <Image src={data.url} h={height} radius="sm" fit="cover" alt={alt} />;
}
